import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import AudienceName from 'audiences-components/audienceName/AudienceName';
import TargetedVisitorsDescription from 'AudienceTargetingUIComponents/components/display/TargetedVisitorsDescription';
import TargetedWebsitesDescription from 'AudienceTargetingUIComponents/components/display/TargetedWebsitesDescription';
import { CONTAINER_TYPES_WITH_TARGETING } from 'web-interactives-data/constants/ContainerConstants';
import CampaignName from 'web-interactives-components/campaigns/CampaignName';
import TriggersDescription from 'web-interactives-components/triggers/TriggersDescription';
import { getInteractiveDisplayData } from 'web-interactives-dashboard-ui/selectors/details';
import StateStatus from 'web-interactives-dashboard-ui/components/shared/StateStatus';
import { Locations } from '../details/Locations';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DetailsPanelContent = () => {
  const interactiveData = useSelector(getInteractiveDisplayData);
  if (!interactiveData) return null;
  const datesToDisplay = ['createdAt', 'lastPublishedAt', 'unpublishedAt', 'scheduledFor', 'unpublishScheduledFor', 'updatedAt', 'archivedAt'];
  const showTargetingData = CONTAINER_TYPES_WITH_TARGETING.includes(interactiveData.containerType);
  return /*#__PURE__*/_jsxs(DescriptionList, {
    children: [/*#__PURE__*/_jsx("dt", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "details.summary.name"
      })
    }), /*#__PURE__*/_jsx("dd", {
      children: interactiveData.name
    }), /*#__PURE__*/_jsx("dt", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "details.summary.state"
      })
    }), /*#__PURE__*/_jsx("dd", {
      children: /*#__PURE__*/_jsx(StateStatus, {
        state: interactiveData.status,
        useTag: true
      })
    }), /*#__PURE__*/_jsx("dt", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "details.summary.type"
      })
    }), /*#__PURE__*/_jsx("dd", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `details.summary.containerType.${interactiveData.containerType}`
      })
    }), datesToDisplay.map(key => interactiveData[key] && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `details.summary.${key}`
        })
      }), /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: 'LLL',
          type: "portalTz",
          value: interactiveData[key]
        })
      })]
    }, key)), /*#__PURE__*/_jsx("dt", {
      children: /*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "details.summary.locationsTooltip"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "details.summary.locations"
        })
      })
    }), /*#__PURE__*/_jsx("dd", {
      "data-test-id": "container-type-field",
      children: /*#__PURE__*/_jsx(Locations, {
        interactiveId: interactiveData.id
      })
    }), /*#__PURE__*/_jsx("dt", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "details.summary.campaign"
      })
    }), /*#__PURE__*/_jsx("dd", {
      children: /*#__PURE__*/_jsx(CampaignName, {
        guid: interactiveData.campaignId,
        showAsLink: true
      })
    }), showTargetingData && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "details.summary.triggers"
        })
      }), /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(TriggersDescription, {
          isShowAlways: interactiveData.isShowAlways,
          triggers: interactiveData.triggers
        })
      })]
    }), showTargetingData && interactiveData.audience && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "details.summary.websites"
        })
      }), /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(TargetedWebsitesDescription, {
          audience: interactiveData.audience
        })
      }), /*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "details.summary.visitors"
        })
      }), /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(TargetedVisitorsDescription, {
          audience: interactiveData.audience,
          audienceComponentProps: {
            showAsLink: true
          },
          audienceNameComponent: AudienceName
        })
      })]
    })]
  });
};
export default DetailsPanelContent;